import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from '@material-ui/core';
import { useEffect } from 'react';
import { UseStore } from 'zustand';
import { AlertStore } from '../../core/alerts';
import { IcdCptApi } from '../../core/icd-cpt-api';
import { orange } from '../../core/theme';
import { showSuccessMessage } from '../../core/toast';
import { LinkButton } from '../common/presentation';
import { MipsApi, MipsTuple } from './mips-api';
import React from 'react';

type OverrideDialogueProps = {
  api: UseStore<MipsApi>;
  icdCpt: IcdCptApi;
  alerts: AlertStore;
};
export function MipsDialogue(props: OverrideDialogueProps) {
  const { api, icdCpt, alerts } = props;
  const openAlert = api((s) => s.alert);

  useEffect(() => {
    if (openAlert) {
    }
  });

  const onIcd = (code: string) => {
    //TODO dx search ?
    icdCpt.findCode({ code });
    console.log(code);
    showSuccessMessage('Diagnosis Added');
    api.setState({ alert: null });
  };

  const onCpt = async (a: MipsTuple) => {
    if (a.cptCodeString !== 'BLANK') {
      const codes = a.cptCodeString.split(',');
      codes.forEach((code) => {
        icdCpt.addCpt(
          {
            code,
            description: { description: a.descriptionString },
          },
          true,
          false,
          {
            modifier: a.modifierString,
            modifiers: a.modifierString ? [a.modifierString] : [],
            isMIPSCode: true,
          }
        );
        //  console.log('mips code', a, code);
      });

      showSuccessMessage('Procedure(s) Added');
      api.setState({ alert: null });
    } else if(openAlert) {
      const a = openAlert;
      a.overrideReason = 'BLANK';
      await alerts.getState().overrideAlert(a, 'BLANK');
      showSuccessMessage('Alert Overridden');
      api.setState({ alert: null });
    }
  };

  const name = api((s) => s.name);
  const procedures = api((s) => s.tuples);
  const diagnoses = api((s) => s.dxCodes);
  const width = 640;

  return (
    <Dialog open={!!openAlert} maxWidth={false} style={{ zIndex: 1500 }}>
      <DialogTitle>MIPS</DialogTitle>
      <DialogContent style={{ minWidth: width, width, fontSize: 12 }}>
        <Grid
          container
          direction="column"
          spacing={2}
          style={{
            width: '100%',
            maxHeight: '52vh',
            overflowX: 'hidden',
            overflowY: 'scroll',
            flexWrap: 'nowrap',
            paddingTop: 0,
            paddingLeft: '6px',
            paddingBottom: '12px',
          }}
        >
          <Grid item>{name}</Grid>

          <Grid item>Procedures</Grid>
          <Grid item container direction="column" style={{ width: '100%' }}>
            {!!procedures?.length &&
              procedures.map((a) => (
                <Grid item>
                  <LinkButton
                    label={
                      a.cptCodeString +
                      ' - ' +
                      (a.modifierString ? a.modifierString + ' - ' : '') +
                      a.descriptionString
                    }
                    color={orange}
                    onClick={() => onCpt(a)}
                    width={width - 68}
                  />
                </Grid>
              ))}
          </Grid>
          {!!diagnoses?.length && <Grid item>Diagnoses</Grid>}
          <Grid item container direction="column" style={{ width: '100%' }}>
            {!!diagnoses?.length &&
              diagnoses.map((a) => (
                <Grid item>
                  <LinkButton
                    label={a}
                    color={orange}
                    onClick={() => onIcd(a)}
                    width={width - 68}
                  />
                </Grid>
              ))}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => api.setState({ alert: null })}
          color="primary"
          variant="outlined"
        >
          {' '}
          Close{' '}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
